import React, { useEffect, useState, useRef } from "react"
import { Link } from "react-router-dom"
import Select from "react-select"
import Flatpickr from "react-flatpickr"
import "flatpickr/dist/themes/material_blue.css"
import SignatureCanvas from "react-signature-canvas";
import Webcam from "react-webcam"
import { addLab, getFrameByFcode, getJob, getLab, getLensByLcode, getPatient, getPatientsByClinicId, getPCAREByVisitId, getTakeFramesByJob, getTakeLensesByJob, getvision, getVisionType, labordernumber, searchFrameByFcode, searchLensByLcode } from "../../service/api"
import { useLocation, useNavigate } from "react-router-dom"
import { toast } from "react-toastify"

import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  CardTitle,
  Label,
  Button,
  Form,
  Input,
  InputGroup,
  Table,
  CardSubtitle,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,

} from "reactstrap"
import { jwtDecode } from "jwt-decode"

const defaultValue = {
  // vc_reference: "",
  patient_name: "",
  patient_id: "",
  date: "",
  patient: "",
  practisc_name: "",
  delivery_date: "",
  order_no: "",
  payment_details: "",
  delivery_info: "",
  order_type: "",
  frame: "",
  frame_color: "",
  frame_size: "",
  frame_material: "",
  frame_type: "",
  frame_shape: "",
  frame_brand: "",
  frame_id: "",
  frame_price: "",
  od_spere: "",
  od_cyl: "",
  od_axis: "",
  od_add: "",
  od_seg_height: "",
  os_spere: "",
  os_cyl: "",
  os_axis: "",
  os_add: "",
  os_seg_height: "",
  pd: "",
  two_pd_number: "",
  pd_left: "",
  pd_right: "",
  lens_material: "",
  lens_tint: "",
  lens_vision: "",
  lens_subvision: "",
  lens_type: "",
  lens_material_od: "",
  lens_material_os: "",
  lens_vision_od: "",
  lens_vision_os: "",
  lens_subvision_od: "",
  lens_subvision_os: "",
  lens_type_od: "",
  lens_type_os: "",
  extra_od: "",
  extra_os: "",
  add_prism: "",
  od_vertical: "",
  od_vb_direction: "",
  od_horizontal: "",
  od_hb_direction: "",
  os_vertical: "",
  os_vb_direction: "",
  os_horizontal: "",
  os_hb_direction: "",
  pre_od_sphere: "",
  pre_od_cyl: "",
  pre_od_axis: "",
  pre_od_aad: "",
  pre_od_segheight: "",
  pre_os_sphere: "",
  pre_os_cyl: "",
  pre_os_axis: "",
  pre_os_aad: "",
  pre_os_segheight: "",
  pre_pd: "",
  pre_pd_left: "",
  pre_pd_right: "",
  authorized_by: "",
  practice_name: "",
  px_number: "",
  additional_notes: "",
  total: "",
  framecode: "",
  lenscode: "",
  frameStockId: "",
  lenseStockId: "",
  job_reference_id: "",
}

const Addlaborder = () => {
  const location = useLocation();
  const navigate = useNavigate();


  const [modalOpen, setModalOpen] = useState(false);
  const [modalOpen1, setModalOpen1] = useState(false);
  const [modalOpen2, setModalOpen2] = useState(false);
  const [modalOpen3, setModalOpen3] = useState(false);
  const [activeInput, setActiveInput] = useState(null);
  const [activeInput1, setActiveInput1] = useState(null);
  const [activeInput2, setActiveInput2] = useState(null);
  const [activeInput3, setActiveInput3] = useState(null);
  const [selectedVision, setSelectedVision] = useState(null);
  const [Labordernumber, setlabordernumber] = useState({});
  const [Labordernumberview, setLabordernumberview] = useState([]);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("token");
  const decoded = token ? jwtDecode(token) : {};
  // const clinicID = decoded?.clinicID;

  const [filteredOptions, setFilteredOptions] = useState([]);
  const [selectedVCRef, setSelectedVCRef] = useState(null);
  const [filteredOptionsvisionType, setFilteredOptionsvisionType] = useState([]);
  const todayDate = new Date().toISOString().split('T')[0];
  const [addData, setAddData] = useState({
    ...defaultValue,
    date: todayDate,
  });
  const [signatureRef, setSignatureRef] = useState(null);
  const redirectApplied = useRef(false);
  const [alluserlist, setallusers] = useState([])
  const [vision, setallvision] = useState({ users: [] })
  const [visionType, setallvisionType] = useState({ users: [] })
  const [selectedGroup, setselectedGroup] = useState(null);
  const [responseData, setResponseData] = React.useState([]);
  const [frameSuggestions, setFrameSuggestions] = useState([]);
  const [lensSuggestions, setLensSuggestions] = useState([]);
  const [frameSearchTerm, setFrameSearchTerm] = useState('');
  const [lenseSearchTerm, setLenseSearchTerm] = useState('');
  const [clinicID, setClinicID] = useState(null);
  const [totals, setTotals] = useState({
    uc: 0,
    hc: 0,
    hmc_blue: 0,
    shmc_blue: 0,
    photo: 0,
  });

  const [selectedTotal, setSelectedTotal] = useState(0);
  // const [imageSrc, setImageSrc] = useState("")

  const [isLabToSupply, setIsLabToSupply] = useState(false);
  const [isPhotochromic, setIsPhotochromic] = useState(false);
  const [prescriptionFromRef, setPrescriptionFromRef] = useState("");

  // Per-eye OD state
  const [filteredOptionsVisionTypeOD, setFilteredOptionsVisionTypeOD] = useState([]);
  const [totalsOD, setTotalsOD] = useState({ uc: 0, hc: 0, hmc_blue: 0, shmc_blue: 0, photo: 0 });
  const [selectedTotalOD, setSelectedTotalOD] = useState(0);
  const [isPhotochromicOD, setIsPhotochromicOD] = useState(false);
  // Per-eye OS state
  const [filteredOptionsVisionTypeOS, setFilteredOptionsVisionTypeOS] = useState([]);
  const [totalsOS, setTotalsOS] = useState({ uc: 0, hc: 0, hmc_blue: 0, shmc_blue: 0, photo: 0 });
  const [selectedTotalOS, setSelectedTotalOS] = useState(0);
  const [isPhotochromicOS, setIsPhotochromicOS] = useState(false);

  const selectedSubvision = filteredOptionsvisionType.find(
    (item) => item._id === addData.lens_subvision
  );

  const selectedVisionType = selectedSubvision?.sub_type || "N/A";
  const framePrice = parseFloat(addData.frame_price || 0) || 0;

  useEffect(() => {
    console.log("Response Data:", visionType);
    console.log("Filtered Options Vision Type:", filteredOptionsvisionType);
  }, [visionType, filteredOptionsvisionType]);

  // useEffect(() => {
  //   const delayDebounceFn = setTimeout(async () => {
  //     if (frameSearchTerm && clinicID) {
  //       try {
  //         const res = await searchFrameByFcode(frameSearchTerm, clinicID);
  //         setFrameSuggestions(res.data);
  //       } catch (error) {
  //         console.error("Error fetching frame suggestions:", error);
  //         setFrameSuggestions([]);
  //       }
  //     } else {
  //       setFrameSuggestions([]);
  //     }
  //   }, 300);

  //   return () => clearTimeout(delayDebounceFn);
  // }, [frameSearchTerm, clinicID]);

  ///////////////////////////////////////

  // useEffect(() => {
  //   const delayDebounceFn = setTimeout(async () => {
  //     if (lenseSearchTerm && clinicID) {
  //       try {
  //         const res = await searchLensByLcode(lenseSearchTerm, clinicID);
  //         setLensSuggestions(res.data);
  //       } catch (error) {
  //         console.error("Error fetching frame suggestions:", error);
  //         setLensSuggestions([]);
  //       }
  //     } else {
  //       setLensSuggestions([]);
  //     }
  //   }, 300);

  //   return () => clearTimeout(delayDebounceFn);
  // }, [lenseSearchTerm, clinicID]);


  useEffect(() => {
    const token = localStorage.getItem("token");

    if (token) {
      try {
        const decoded = jwtDecode(token);

        console.log("✅ Token clinicID:", decoded?.clinicID);

        setClinicID(decoded?.clinicID);
      } catch (err) {
        console.error("Invalid token", err);
      }
    }
  }, []);

  useEffect(() => {
    if (!clinicID) return;

    const delayDebounceFn = setTimeout(async () => {
      if (frameSearchTerm.trim()) {
        try {
          console.log("Frame Search Clinic:", clinicID);

          const res = await searchFrameByFcode(
            frameSearchTerm,
            clinicID
          );

          setFrameSuggestions(res.data);
        } catch (error) {
          console.error(error);
          setFrameSuggestions([]);
        }
      } else {
        setFrameSuggestions([]);
      }
    }, 300);

    return () => clearTimeout(delayDebounceFn);
  }, [frameSearchTerm, clinicID]);

  useEffect(() => {
    if (!clinicID) return;

    const delayDebounceFn = setTimeout(async () => {
      if (lenseSearchTerm.trim()) {
        try {
          console.log("Lens Search Clinic:", clinicID);

          const res = await searchLensByLcode(
            lenseSearchTerm,
            clinicID
          );

          setLensSuggestions(res.data);
        } catch (error) {
          console.error(error);
          setLensSuggestions([]);
        }
      } else {
        setLensSuggestions([]);
      }
    }, 300);

    return () => clearTimeout(delayDebounceFn);
  }, [lenseSearchTerm, clinicID]);
  const onValueChange = async (e) => {
    const { name, value } = e.target;

    setAddData((prevData) => {
      const updatedData = { ...prevData, [name]: value };

      if (name === "pd_left" || name === "pd_right") {
        const l = parseFloat(name === "pd_left" ? value : prevData.pd_left) || 0;
        const r = parseFloat(name === "pd_right" ? value : prevData.pd_right) || 0;
        if (l + r > 0) updatedData.pd = (l + r).toString();
      }

      if (name === "lens_subvision") {
        if (filteredOptionsvisionType && filteredOptionsvisionType.length > 0) {
          const selectedOption = filteredOptionsvisionType.find(
            (user) => user._id === value
          );
          if (selectedOption) {
            setTotals({
              uc: selectedOption.uc ?? 0,
              hc: selectedOption.hc ?? 0,
              hmc_blue: selectedOption.hmc_blue ?? 0,
              shmc_blue: selectedOption.shmc_blue ?? 0,
              photo: selectedOption.photo ?? 0,
            });
          }
        }
      }
      if (name === "lens_type") {
        const coatingPrice = parseFloat(totals[value]) || 0;
        const photoPrice = isPhotochromic ? (parseFloat(totals.photo) || 0) : 0;
        setSelectedTotal(coatingPrice + photoPrice);
      }
      return updatedData;
    });
    if (name === "frame") {
      setIsLabToSupply(value === "Supply Frame");
      // setIsLabToSupply(value === "Lab To Supply");
    }
    //////////////////////////////////////////////////////
    if (name === "framecode") {
      setAddData((prev) => ({
        ...prev,
        [name]: value
      }));

      try {
        const response = await getFrameByFcode(value.trim());
        if (response?.data?.data?.length > 0) {
          const frameData = response.data.data[0]; // if it's an array of one result
          console.log("🎯 Frame data by fcode:", frameData);

          // Auto-fill any fields you need from frameData:
          setAddData((prev) => ({
            ...prev,
            fname: frameData.fname,
            fqty: frameData.fqty,
            fname_id: frameData.fname_id?._id || "", // if needed
            // add any other field here as required
          }));
        } else {
          console.warn("No frame found with given code.");
          // Optionally clear old data
          setAddData((prev) => ({
            ...prev,
            fname: "",
            fqty: 0,
            fname_id: "",
          }));
        }
      } catch (error) {
        console.error("Error fetching frame by fcode:", error);
      }

      return;
    }
    if (name === "lenscode") {
      setAddData((prev) => ({
        ...prev,
        [name]: value
      }));

      try {
        const response = await getLensByLcode(value.trim());
        if (response?.data?.data?.length > 0) {
          const lensData = response.data.data[0]; // if it's an array of one result
          console.log("🎯 lens data by lcode:", lensData);

          // Auto-fill any fields you need from lensData:
          setAddData((prev) => ({
            ...prev,
            lname: lensData.lname,
            lqty: lensData.lqty,
            lname_id: lensData.lname_id?._id || "", // if needed
            // add any other field here as required
          }));
        } else {
          console.warn("No frame found with given code.");
          // Optionally clear old data
          setAddData((prev) => ({
            ...prev,
            lname: "",
            lqty: 0,
            lname_id: "",
          }));
        }
      } catch (error) {
        console.error("Error fetching frame by lcode:", error);
      }

      return;
    }

  };
  const clearSignature = () => {
    signatureRef.clear();
  };

  const saveSignature = () => {
    // Handle saving the signature image or data if needed
    console.log("Signature saved:", signatureRef.toDataURL("image/png"));
  };

  const handleInputClick = inputName => {
    setActiveInput(inputName);
    setModalOpen(true);
  };
  const handleInputClick1 = inputName => {
    setActiveInput1(inputName);
    setModalOpen1(true);
  };
  const handleInputClick2 = inputName => {
    setActiveInput2(inputName);
    setModalOpen2(true);
  };
  const handleInputClick3 = inputName => {
    setActiveInput3(inputName);
    setModalOpen3(true);
  };

  const handleSelectValue = value => {
    setAddData({
      ...addData,
      [activeInput]: value,
    });
    setModalOpen(false);
  };
  const handleSelectValue1 = value => {
    setAddData({
      ...addData,
      [activeInput1]: value,
    });
    setModalOpen1(false);
  };
  const handleSelectValue2 = value => {
    setAddData({
      ...addData,
      [activeInput2]: value,
    });
    `setModalOpen2`(false);
  };
  const handleSelectValue3 = value => {
    setAddData(prev => {
      const updated = { ...prev, [activeInput3]: value };
      // Recalculate combined pd whenever pd_left or pd_right changes
      const l = parseFloat(activeInput3 === "pd_left" ? value : prev.pd_left) || 0;
      const r = parseFloat(activeInput3 === "pd_right" ? value : prev.pd_right) || 0;
      if (l + r > 0) updated.pd = (l + r).toString();
      return updated;
    });
    setModalOpen3(false);
  };



  const renderDropdownOptions = () => {
    const options = [];
    for (let i = 1; i <= 100; i++) {
      options.push(
        <option key={i} value={i}>
          {i}
        </option>
      );
    }
    return options;
  };

  const renderDropdownOptions1 = () => {
    const options = [];
    for (let i = 1; i <= 50; i++) {
      options.push(
        <option key={i} value={i}>
          {i}
        </option>
      );
    }
    return options;
  };

  const fileInputRef = useRef(null);
  const handleClick = () => {
    fileInputRef.current.click();
  };

  const [isTwoPD, setIsTwoPD] = useState(false);

  const onCheckboxChange = e => {
    setIsTwoPD(e.target.checked);
  };

  useEffect(() => {
    getPatientAll();
    getVision();
    getVisiontype();
    getjobdata();
    getlabordernumber();
    getlabordernumberview();
    // getLabdata();
  }, [])

  const getPatientAll = async () => {
    try {
      const token = localStorage.getItem("token");
      let response;
      if (token) {
        const decoded = jwtDecode(token);
        const clinicID = decoded?.clinicID;

        response = clinicID
          ? await getPatientsByClinicId(clinicID)
          : await getPatient();

        if (response?.data?.data) {
          setallusers(response.data.data);
        } else {
          setallusers([]);
        }
      }
    } catch (error) {
      console.log("Error while fetching patient data:", error);
      setallusers([]);
    } finally {
      setLoading(false);
    }
  };



  function handleSelectGroup(selectedOption) {
    setselectedGroup(selectedOption);
  }

  const getVision = async () => {
    try {
      let response = await getvision()
      if (response.error) {
        console.log("Error while fetching data:", response.error)
      } else {
        setallvision({ users: response.data || [] })
      }
    } catch (error) {
      console.log("Error while fetching data:", error)
    }
  }

  const getVisiontype = async () => {
    try {
      const response = await getVisionType();
      if (response.error) {
        console.log("Error while fetching data:", response.error);
      } else {
        setallvisionType({ users: response.data || [] });
        console.log("Vision type data fetched:", response.data);
      }
    } catch (error) {
      console.log("Error while fetching vision type data:", error);
    }
  };


  const getlabordernumber = async () => {
    try {
      const response = await labordernumber();
      // Ensure it's not an array
      if (Array.isArray(response.data)) {
        setlabordernumber(response.data[0]);
      } else {
        setlabordernumber(response.data);
      }
    } catch (error) {
      console.error("Error fetching lab order number:", error);
    }
  };

  const getlabordernumberview = async () => {
    const response = await labordernumber();
    setLabordernumberview(response.data);
  }



  const [allvisit, setallvisit] = useState([]);

  // Auto-fill from Job list redirect
  // Wait for BOTH allvisit and visionType.users to be ready before triggering,
  // because handlevisitChange needs visionType.users to populate per-eye lens dropdowns.
  // Use a ref flag so this only fires once even if deps update multiple times.
  useEffect(() => {
    const state = location.state;
    if (!state || !state.vc_reference) return;
    if (allvisit.length === 0 || visionType.users.length === 0) return;
    if (redirectApplied.current) return;

    const selectedJob = allvisit.find(job => job.vc_reference === state.vc_reference);
    if (!selectedJob) return;

    redirectApplied.current = true;
    // Call the same function used by manual selection — populates patientcare/TakeFrame/TakeLens data
    handlevisitChange({ value: selectedJob.vc_reference });
  }, [allvisit, visionType.users.length, location.state]);

  const getjobdata = async () => {
    let response = await getJob();
    setallvisit(response.data);
  }

  // const getLabdata = async () => {
  //   let response = await getLab();
  //   setallvisit(response.data);
  // }

  // const handlevisitChange = (selectedOption) => {
  //   const selectedConsignee = allvisit.find(patient => patient.vc_reference === selectedOption.value);
  //   if (selectedConsignee) {
  //     setAddData({
  //       ...addData,
  //       jobId: selectedConsignee._id,
  //       vc_reference: selectedConsignee.vc_reference,
  //       practisc_name: selectedConsignee.practisc_name,
  //       patient_name: selectedConsignee.patient_name,
  //       patient_id: selectedConsignee._id,
  //     });
  //   }
  //   console.log(addData);
  // };
  const handlevisitChange = async (selectedOption) => {

    const selectedJob = allvisit.find(
      job => job.vc_reference === selectedOption.value
    );

    if (!selectedJob) return;

    const patient = selectedJob.patientID;

    setSelectedVCRef({ value: selectedJob.vc_reference, label: selectedJob.vc_reference });

    // ✅ update form data with job info
    setAddData(prev => ({
      ...prev,
      jobId: selectedJob._id,
      job_reference_id: selectedJob._id,
      vc_reference: selectedJob.vc_reference,
      practisc_name: selectedJob.practisc_name,
      patient_name: `${patient.firstname} ${patient.lastname}`,
      patient_id: patient._id
    }));

    // ✅ AUTO SELECT PATIENT DROPDOWN
    setselectedGroup({
      value: patient._id,
      label: `${patient.firstname} ${patient.lastname} (${patient.mpino})`
    });

    let pcareFrameFilled = false;
    let pcareLensFilled = false;

    // ── Step 1: patientcare → prescription + frame + lens (if available) ──
    const visitId = selectedJob.visit?._id || selectedJob.visit;
    if (visitId) {
      try {
        const pcareRes = await getPCAREByVisitId(visitId);
        const pcare = Array.isArray(pcareRes?.data) ? pcareRes.data[0] : pcareRes?.data;
        if (pcare && !pcare.message) {
          setPrescriptionFromRef(pcare.visit_no || selectedJob.vc_reference || "");

          // Determine what patientcare has
          const pcFrameBrand = pcare.frames_brand || pcare.frame_brand || "";
          const pcFrameColor = pcare.frame_color || "";
          const pcFrameSize = pcare.frame_size || "";
          const pcFrameMat = pcare.frame_material || "";
          const pcFrameType = pcare.frame_type || "";
          const pcFrameShape = pcare.frame_shape || "";
          pcareFrameFilled = !!(pcFrameBrand || pcFrameColor || pcFrameSize || pcFrameMat || pcFrameType || pcFrameShape);

          const pcVisionOD = (pcare.lens_vision_od?._id || pcare.lens_vision_od || pcare.lens_vision?._id || pcare.lens_vision || "").toString();
          const pcVisionOS = (pcare.lens_vision_os?._id || pcare.lens_vision_os || "").toString();
          const pcSubOD = (pcare.lens_subvision_od?._id || pcare.lens_subvision_od || pcare.lens_subvision?._id || pcare.lens_subvision || "").toString();
          const pcSubOS = (pcare.lens_subvision_os?._id || pcare.lens_subvision_os || pcare.lens_subvision?._id || pcare.lens_subvision || "").toString();
          const pcMatOD = pcare.lens_material_od || pcare.lens_material || pcare.material || "";
          const pcMatOS = pcare.lens_material_os || pcare.lens_material || pcare.material || "";
          const pcTypeOD = pcare.lens_type_od || pcare.type || "";
          const pcTypeOS = pcare.lens_type_os || "";
          const pcExtraOD = pcare.extra_od || pcare.extra || "no";
          const pcExtraOS = pcare.extra_os || pcare.extra || "no";
          pcareLensFilled = !!(pcVisionOD || pcVisionOS || pcMatOD || pcMatOS);

          const updates = {
            // Prescription
            od_spere: pcare.Prescription_right_sphere || pcare.od_spere || "",
            od_cyl: pcare.Prescription_right_cyl || pcare.od_cyl || "",
            od_axis: pcare.Prescription_right_axis || pcare.od_axis || "",
            od_add: pcare.Prescription_right_add || pcare.od_add || "",
            od_seg_height: pcare.Prescription_right_seg_height || pcare.od_seg_height || "",
            os_spere: pcare.Prescription_left_sphere || pcare.os_spere || "",
            os_cyl: pcare.Prescription_left_cyl || pcare.os_cyl || "",
            os_axis: pcare.Prescription_left_axis || pcare.os_axis || "",
            os_add: pcare.Prescription_left_add || pcare.os_add || "",
            os_seg_height: pcare.Prescription_left_seg_height || pcare.os_seg_height || "",
            pd_left: pcare.Prescription_left_pd || pcare.pd_left || "",
            pd_right: pcare.Prescription_right_pd || pcare.pd_right || "",
            pd: (() => {
              const l = parseFloat(pcare.Prescription_left_pd || pcare.pd_left || 0);
              const r = parseFloat(pcare.Prescription_right_pd || pcare.pd_right || 0);
              return (l + r) > 0 ? (l + r).toString() : (pcare.pd || "");
            })(),
          };

          // Frame from patientcare
          if (pcareFrameFilled) {
            updates.frame_brand = pcFrameBrand;
            updates.frame_color = pcFrameColor;
            updates.frame_size = pcFrameSize;
            updates.frame_material = pcFrameMat;
            updates.frame_type = pcFrameType;
            updates.frame_shape = pcFrameShape;
            updates.framecode = pcare.frame_code || "";
            updates.frame_id = pcare.frame_id?._id || pcare.frame_id || "";
            updates.frame_price = pcare.frame_id?.price?.toString() || pcare.price?.toString() || "";
            updates.frame = "Supply Frame";
            // updates.frame = "Lab To Supply";
            setIsLabToSupply(true);
            if (pcare.frame_image) setWebcamImage(pcare.frame_image);
          }

          // Lens from patientcare
          if (pcareLensFilled) {
            updates.lens_material_od = pcMatOD;
            updates.lens_material_os = pcMatOS;
            updates.lens_vision_od = pcVisionOD;
            updates.lens_vision_os = pcVisionOS;
            updates.lens_subvision_od = pcSubOD;
            updates.lens_subvision_os = pcSubOS;
            updates.lens_type_od = pcTypeOD;
            updates.lens_type_os = pcTypeOS;
            updates.extra_od = pcExtraOD;
            updates.extra_os = pcExtraOS;
            // ── Lens code from patientcare ──
            if (pcare.lens_code) {
              updates.lenscode = pcare.lens_code;
              updates.lenseStockId = pcare.lens_stock_id || pcare.lens_code_id || "";
            }

            // OD vision filter + totals
            if (pcVisionOD) {
              const filtOD = visionType.users.filter(vt => (vt.vision?._id || vt.vision)?.toString() === pcVisionOD);
              setFilteredOptionsVisionTypeOD(filtOD);
              const matchOD = filtOD.find(vt => vt._id?.toString() === pcSubOD);
              if (matchOD) {
                const tOD = { uc: matchOD.uc ?? 0, hc: matchOD.hc ?? 0, hmc_blue: matchOD.hmc_blue ?? 0, shmc_blue: matchOD.shmc_blue ?? 0, photo: matchOD.photo ?? 0 };
                setTotalsOD(tOD);
                const isPhotoOD = pcExtraOD === "yes";
                setSelectedTotalOD((pcTypeOD ? (parseFloat(tOD[pcTypeOD]) || 0) : 0) + (isPhotoOD ? (parseFloat(tOD.photo) || 0) : 0));
                setIsPhotochromicOD(isPhotoOD);
              }
            }
            // OS vision filter + totals
            if (pcVisionOS) {
              const filtOS = visionType.users.filter(vt => (vt.vision?._id || vt.vision)?.toString() === pcVisionOS);
              setFilteredOptionsVisionTypeOS(filtOS);
              const isPhotoOS = pcExtraOS === "yes";
              setIsPhotochromicOS(isPhotoOS);
              const matchOS = filtOS.find(vt => vt._id?.toString() === pcSubOS);
              if (matchOS) {
                const tOS = { uc: matchOS.uc ?? 0, hc: matchOS.hc ?? 0, hmc_blue: matchOS.hmc_blue ?? 0, shmc_blue: matchOS.shmc_blue ?? 0, photo: matchOS.photo ?? 0 };
                setTotalsOS(tOS);
                setSelectedTotalOS((pcTypeOS ? (parseFloat(tOS[pcTypeOS]) || 0) : 0) + (isPhotoOS ? (parseFloat(tOS.photo) || 0) : 0));
              }
            }
          }

          setAddData(prev => ({ ...prev, ...updates }));
        }
      } catch (err) {
        console.log("No patientcare found for this job's visit:", err.message);
      }
    }

    // ── Step 2: TakeFrame fallback (only if patientcare had no frame data) ──
    if (!pcareFrameFilled) {
      try {
        const tfRes = await getTakeFramesByJob(selectedJob._id);
        const tf = Array.isArray(tfRes?.data) && tfRes.data.length > 0 ? tfRes.data[0] : null;
        if (tf) {
          setAddData(prev => ({
            ...prev,
            frame_brand: tf.frame_brand || prev.frame_brand,
            framecode: tf.frame_code || prev.framecode,
            frame_id: tf.frame_id || prev.frame_id,
            frame_color: tf.frame_color || prev.frame_color,
            frame_size: tf.frame_size || prev.frame_size,
            frame_price: tf.price || prev.frame_price,
            frame_material: tf.frame_material || prev.frame_material,
            frame_type: tf.frame_type || prev.frame_type,
            frame_shape: tf.frame_shape || prev.frame_shape,
            ...(tf.frame_brand || tf.frame_color || tf.frame_size || tf.frame_material || tf.frame_type || tf.frame_shape
              ? { frame: "Supply Frame" } : {}),
            // ? { frame: "Lab To Supply" } : {}),
          }));
          if (tf.frame_image) setWebcamImage(tf.frame_image);
          if (tf.frame_brand || tf.frame_color || tf.frame_size || tf.frame_material || tf.frame_type || tf.frame_shape)
            setIsLabToSupply(true);
          setPrescriptionFromRef(prev => prev || selectedJob.vc_reference || "");
        }
      } catch (err) {
        console.log("No TakeFrame found for this job:", err.message);
      }
    }

    // ── Step 3: TakeLens fallback (only if patientcare had no lens data) ──
    if (!pcareLensFilled) {
      try {
        const tlRes = await getTakeLensesByJob(selectedJob._id);
        const tl = Array.isArray(tlRes?.data) && tlRes.data.length > 0 ? tlRes.data[0] : null;
        if (tl) {
          const tlVisionIdOD = (tl.lens_vision_od?._id || tl.lens_vision_od || "").toString();
          const tlSubvisionIdOD = (tl.lens_subvision_od?._id || tl.lens_subvision_od || "").toString();
          const tlVisionIdOS = (tl.lens_vision_os?._id || tl.lens_vision_os || "").toString();
          const tlSubvisionIdOS = (tl.lens_subvision_os?._id || tl.lens_subvision_os || tl.lens_subvision?._id || tl.lens_subvision || "").toString();

          if (tlVisionIdOD) {
            const filtOD = visionType.users.filter(vt => (vt.vision?._id || vt.vision)?.toString() === tlVisionIdOD);
            setFilteredOptionsVisionTypeOD(filtOD);
            const matchOD = filtOD.find(vt => vt._id?.toString() === tlSubvisionIdOD);
            if (matchOD) {
              const tOD = { uc: matchOD.uc ?? 0, hc: matchOD.hc ?? 0, hmc_blue: matchOD.hmc_blue ?? 0, shmc_blue: matchOD.shmc_blue ?? 0, photo: matchOD.photo ?? 0 };
              setTotalsOD(tOD);
              const isPhotoOD = tl.extra_od === "yes";
              setSelectedTotalOD((tl.lens_type_od ? (parseFloat(tOD[tl.lens_type_od]) || 0) : 0) + (isPhotoOD ? (parseFloat(tOD.photo) || 0) : 0));
              setIsPhotochromicOD(isPhotoOD);
            }
          }
          if (tlVisionIdOS) {
            const filtOS = visionType.users.filter(vt => (vt.vision?._id || vt.vision)?.toString() === tlVisionIdOS);
            setFilteredOptionsVisionTypeOS(filtOS);
            const isPhotoOS = (tl.extra_os || tl.extra) === "yes";
            setIsPhotochromicOS(isPhotoOS);
            const matchOS = filtOS.find(vt => vt._id?.toString() === tlSubvisionIdOS);
            if (matchOS) {
              const tOS = { uc: matchOS.uc ?? 0, hc: matchOS.hc ?? 0, hmc_blue: matchOS.hmc_blue ?? 0, shmc_blue: matchOS.shmc_blue ?? 0, photo: matchOS.photo ?? 0 };
              setTotalsOS(tOS);
              setSelectedTotalOS((tl.lens_type_os ? (parseFloat(tOS[tl.lens_type_os]) || 0) : 0) + (isPhotoOS ? (parseFloat(tOS.photo) || 0) : 0));
            }
          }

          setAddData(prev => ({
            ...prev,
            lens_material_od: tl.lens_material_od || prev.lens_material_od,
            lens_material_os: tl.lens_material_os || prev.lens_material_os,
            lens_vision_od: tlVisionIdOD || prev.lens_vision_od,
            lens_vision_os: tlVisionIdOS || prev.lens_vision_os,
            lens_subvision_od: tlSubvisionIdOD || prev.lens_subvision_od,
            lens_subvision_os: tlSubvisionIdOS || prev.lens_subvision_os,
            lens_type_od: tl.lens_type_od || prev.lens_type_od,
            lens_type_os: tl.lens_type_os || prev.lens_type_os,
            extra_od: tl.extra_od || prev.extra_od,
            extra_os: tl.extra_os || tl.extra || prev.extra_os,
          }));
          setPrescriptionFromRef(prev => prev || selectedJob.vc_reference || "");
        }
      } catch (err) {
        console.log("No TakeLens found for this job:", err.message);
      }
    }
  };

  const handleVisionChange = (e) => {
    const selectedVision = e.target.value;

    setSelectedVision(selectedVision); // Store selected vision ID

    const matchedVision = vision.users.find(
      (user) => user._id === selectedVision
    );

    setAddData((prev) => ({
      ...prev,
      lens_vision: selectedVision, // ✅ Add this line
      lens_vision_id: selectedVision,
      lens_vision_name: matchedVision ? matchedVision.vision : "",
    }));

    // Filter vision types for selected vision
    const filteredTypes = visionType.users.filter(
      (vt) => (vt.vision?._id || vt.vision)?.toString() === selectedVision
    );
    setFilteredOptionsvisionType(filteredTypes);
  };

  const handlePhotochromicChange = (e) => {
    const checked = e.target.checked;
    setIsPhotochromic(checked);
    const coatingPrice = parseFloat(totals[addData.lens_type]) || 0;
    const photoPrice = checked ? (parseFloat(totals.photo) || 0) : 0;
    setSelectedTotal(coatingPrice + photoPrice);
    setAddData(prev => ({ ...prev, extra: checked ? "yes" : "no" }));
  };

  const handleVisionChangeOD = (e) => {
    const selectedId = e.target.value;
    const filteredTypes = visionType.users.filter(
      vt => (vt.vision?._id || vt.vision)?.toString() === selectedId
    );
    setFilteredOptionsVisionTypeOD(filteredTypes);
    setAddData(prev => ({ ...prev, lens_vision_od: selectedId, lens_subvision_od: "" }));
    setTotalsOD({ uc: 0, hc: 0, hmc_blue: 0, shmc_blue: 0, photo: 0 });
    setSelectedTotalOD(0);
  };

  const handleVisionChangeOS = (e) => {
    const selectedId = e.target.value;
    const filteredTypes = visionType.users.filter(
      vt => (vt.vision?._id || vt.vision)?.toString() === selectedId
    );
    setFilteredOptionsVisionTypeOS(filteredTypes);
    setAddData(prev => ({ ...prev, lens_vision_os: selectedId, lens_subvision_os: "" }));
    setTotalsOS({ uc: 0, hc: 0, hmc_blue: 0, shmc_blue: 0, photo: 0 });
    setSelectedTotalOS(0);
  };

  const handleSubvisionChangeOD = (e) => {
    const subId = e.target.value;
    setAddData(prev => ({ ...prev, lens_subvision_od: subId }));
    const matchedSub = filteredOptionsVisionTypeOD.find(vt => vt._id?.toString() === subId);
    if (matchedSub) {
      const t = { uc: matchedSub.uc ?? 0, hc: matchedSub.hc ?? 0, hmc_blue: matchedSub.hmc_blue ?? 0, shmc_blue: matchedSub.shmc_blue ?? 0, photo: matchedSub.photo ?? 0 };
      setTotalsOD(t);
      const coatingPrice = addData.lens_type_od ? (parseFloat(t[addData.lens_type_od]) || 0) : 0;
      const photoPrice = isPhotochromicOD ? (parseFloat(t.photo) || 0) : 0;
      setSelectedTotalOD(coatingPrice + photoPrice);
    }
  };

  const handleSubvisionChangeOS = (e) => {
    const subId = e.target.value;
    setAddData(prev => ({ ...prev, lens_subvision_os: subId }));
    const matchedSub = filteredOptionsVisionTypeOS.find(vt => vt._id?.toString() === subId);
    if (matchedSub) {
      const t = { uc: matchedSub.uc ?? 0, hc: matchedSub.hc ?? 0, hmc_blue: matchedSub.hmc_blue ?? 0, shmc_blue: matchedSub.shmc_blue ?? 0, photo: matchedSub.photo ?? 0 };
      setTotalsOS(t);
      const coatingPrice = addData.lens_type_os ? (parseFloat(t[addData.lens_type_os]) || 0) : 0;
      const photoPrice = isPhotochromicOS ? (parseFloat(t.photo) || 0) : 0;
      setSelectedTotalOS(coatingPrice + photoPrice);
    }
  };

  const handleCoatingChangeOD = (e) => {
    const val = e.target.value;
    setAddData(prev => ({ ...prev, lens_type_od: val }));
    const coatingPrice = parseFloat(totalsOD[val]) || 0;
    const photoPrice = isPhotochromicOD ? (parseFloat(totalsOD.photo) || 0) : 0;
    setSelectedTotalOD(coatingPrice + photoPrice);
  };

  const handleCoatingChangeOS = (e) => {
    const val = e.target.value;
    setAddData(prev => ({ ...prev, lens_type_os: val }));
    const coatingPrice = parseFloat(totalsOS[val]) || 0;
    const photoPrice = isPhotochromicOS ? (parseFloat(totalsOS.photo) || 0) : 0;
    setSelectedTotalOS(coatingPrice + photoPrice);
  };

  const handlePhotochromicChangeOD = (e) => {
    const checked = e.target.checked;
    setIsPhotochromicOD(checked);
    const coatingPrice = parseFloat(totalsOD[addData.lens_type_od]) || 0;
    const photoPrice = checked ? (parseFloat(totalsOD.photo) || 0) : 0;
    setSelectedTotalOD(coatingPrice + photoPrice);
    setAddData(prev => ({ ...prev, extra_od: checked ? "yes" : "no" }));
  };

  const handlePhotochromicChangeOS = (e) => {
    const checked = e.target.checked;
    setIsPhotochromicOS(checked);
    const coatingPrice = parseFloat(totalsOS[addData.lens_type_os]) || 0;
    const photoPrice = checked ? (parseFloat(totalsOS.photo) || 0) : 0;
    setSelectedTotalOS(coatingPrice + photoPrice);
    setAddData(prev => ({ ...prev, extra_os: checked ? "yes" : "no" }));
  };

  // const handleVisionChange = (e) => {
  //   const selectedVision = e.target.value;

  //   setSelectedVision(selectedVision); // Store selected vision ID
  //   const matchedVision = vision.users.find((user) => user._id === selectedVision);

  //   setAddData({
  //     ...addData,
  //     lens_vision_id: selectedVision,
  //     lens_vision_name: matchedVision ? matchedVision.vision : "",
  //   });

  //   // Dynamically filter the visionType
  //   const filteredTypes = visionType.users.filter((vt) => vt.vision._id === selectedVision);
  //   setFilteredOptionsvisionType(filteredTypes);
  // };
  const handleSubmit = async e => {
    e.preventDefault();

    if (signatureRef.isEmpty()) {
      toast.error("Please sign before saving.");
      return;
    }

    try {
      const signatureImage = signatureRef.toDataURL("image/png");
      const formData = new FormData();
      const resolvedVcReference =
        selectedVCRef?.value ||
        addData?.vc_reference ||
        location.state?.vc_reference ||
        "";

      const blob = await fetch(signatureImage).then(r => r.blob());
      formData.append("signature", blob, `signature_${Date.now()}.png`);

      // Skip empty strings — prevents Mongoose ObjectId cast errors for ref fields
      Object.keys(addData).forEach(key => {
        let val = addData[key];
        // If the value is a populated object (e.g. frame_id populated by API), extract its _id
        if (val !== null && val !== undefined && typeof val === "object" && !(val instanceof File) && !(val instanceof Blob)) {
          val = val._id || "";
        }
        if (val !== "" && val !== null && val !== undefined) {
          formData.append(key, val);
        }
      });

      formData.delete("total"); // Clear any existing 'total'
      formData.append("total", (selectedTotalOD + selectedTotalOS + framePrice).toString());
      formData.delete("total_od");
      formData.append("total_od", selectedTotalOD.toString());
      formData.delete("total_os");
      formData.append("total_os", selectedTotalOS.toString());
      formData.delete("order_no");
      formData.append("order_no", Labordernumber?.order_no?.toString() || "");
      formData.delete("vc_reference");
      if (resolvedVcReference) {
        formData.append("vc_reference", resolvedVcReference);
      }
      const resolvedJobRefId = addData?.job_reference_id || "";
      formData.delete("job_reference_id");
      if (resolvedJobRefId) {
        formData.append("job_reference_id", resolvedJobRefId);
      }
      for (let pair of formData.entries()) {
        console.log(`${pair[0]}: ${pair[1]}`);
      }
      const response = await addLab(formData);
      console.log("Response:", response.data);
      // Use the order_no that the backend actually assigned (server-side generated)
      if (response.data?.order_no) {
        setlabordernumber({ order_no: response.data.order_no });
      }
      toast.success("User saved successfully.", {
        position: "top-center",
        autoClose: 1500,
      });
      setTimeout(() => navigate("/LabOrderList"), 1500);
    } catch (error) {
      console.error("Error saving user:", error);
      toast.error("Failed to save user. Check console for details.");
    }
  };



  const [frameCaptureModal, setFrameCaptureModal] = useState(false);
  const [imageZoomModal, setImageZoomModal] = useState(false);
  const [webcamImage, setWebcamImage] = useState(null);
  const webcamRef = useRef(null);
  const captureImage = () => {
    const imageSrc = webcamRef.current.getScreenshot();

    // Store in webcamImage state (for preview)
    setWebcamImage(imageSrc);

    // Store in main patientcare data
    setAddData(prev => ({ ...prev, frame_image: imageSrc }));

    // Close the modal
    setFrameCaptureModal(false);
  };

  document.title = "Lab Order Form | optum";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>

          {/* ── Page Header ── */}
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div>
              <h4 className="mb-0" style={{ color: "#343a40", fontWeight: 700 }}>Lab Order Form</h4>
              <p className="mb-0 text-muted" style={{ fontSize: 12 }}>Optical lab prescription order</p>
            </div>
            <Link to="/LabOrderList" className="btn btn-sm px-4 py-2"
              style={{ background: "#f46a6a", color: "#fff", fontWeight: 600, borderRadius: 6, border: "none" }}>
              ← Back to List
            </Link>
          </div>
          <Form>

            {/* ══════════════════════════════════════
                §1  ORDER INFORMATION
            ══════════════════════════════════════ */}
            <Card className="mb-3" style={{ border: "none", borderRadius: 10, boxShadow: "0 2px 12px rgba(0,0,0,0.07)" }}>
              <div style={{ background: "linear-gradient(90deg,#f46a6a,#ff8282)", padding: "10px 20px", borderRadius: "10px 10px 0 0", display: "flex", alignItems: "center", gap: 8 }}>
                <span style={{ background: "rgba(255,255,255,0.25)", color: "#fff", borderRadius: "50%", width: 22, height: 22, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 11, fontWeight: 800 }}>1</span>
                <span style={{ color: "#fff", fontWeight: 700, fontSize: 13 }}>Order Information</span>
              </div>
              <CardBody className="pt-3 pb-2">
                <Row>
                  <Col md={3}><div className="mb-3">
                    <Label style={{ fontSize: 12, fontWeight: 600 }}>JOB Reference No. <span className="text-danger">*</span></Label>
                    <Select
                      value={selectedVCRef}
                      options={filteredOptions.map(patient => ({ value: patient.vc_reference, label: patient.vc_reference }))}
                      onInputChange={(inputValue) => {
                        const filtered = allvisit
                          .filter(patient => patient.vc_reference.toLowerCase().includes(inputValue.toLowerCase()))
                          .slice(0, 5);
                        setFilteredOptions(filtered);
                      }}
                      onChange={handlevisitChange}
                      className="form-control p-0 border-0"
                      name="vc_reference"
                      isSearchable
                    />
                  </div></Col>
                  <Col md={3}><div className="mb-3">
                    <Label style={{ fontSize: 12, fontWeight: 600 }}>Patient</Label>
                    <Select
                      value={selectedGroup}
                      onChange={handleSelectGroup}
                      options={alluserlist.map((patient) => ({
                        value: patient._id,
                        label: `${patient.firstname} ${patient.lastname} (${patient.mpino})`
                      }))}
                      className="select2-selection p-0 border-0"
                    />
                  </div></Col>
                  <Col md={2}><div className="mb-3">
                    <Label style={{ fontSize: 12, fontWeight: 600 }}>Date</Label>
                    <Input type="date" value={addData.date} className="form-control" name="date" onChange={e => onValueChange(e)} />
                  </div></Col>
                  <Col md={2}><div className="mb-3">
                    <Label style={{ fontSize: 12, fontWeight: 600 }}>Est. Delivery Date</Label>
                    <Input type="date" className="form-control" name="delivery_date" onChange={e => onValueChange(e)} />
                  </div></Col>
                  <Col md={2}><div className="mb-3">
                    <Label style={{ fontSize: 12, fontWeight: 600 }}>Order No.</Label>
                    <Input type="text" className="form-control" value={Labordernumber.order_no || ""} readOnly
                      style={{ background: "#fff8f8", fontWeight: 700, color: "#f46a6a", cursor: "not-allowed", border: "1px solid #f46a6a" }} />
                    <Input type="text" hidden value={Labordernumber.order_no} name="order_no" onChange={e => onValueChange(e)} />
                  </div></Col>
                  <Col md={3}><div className="mb-3">
                    <Label style={{ fontSize: 12, fontWeight: 600 }}>Practice Name <span className="text-danger">*</span></Label>
                    <Input type="text" className="form-control" name="practisc_name" value={addData.practisc_name} placeholder="Practice name" onChange={e => onValueChange(e)} />
                  </div></Col>
                  <Col md={3}><div className="mb-3">
                    <Label style={{ fontSize: 12, fontWeight: 600 }}>Order Type</Label>
                    <select name="order_type" className="form-control" onChange={e => onValueChange(e)}>
                      <option>Select</option><option>New Job</option><option>Return Job</option><option>Frame Repair</option>
                    </select>
                  </div></Col>
                  <Col md={3}><div className="mb-3">
                    <Label style={{ fontSize: 12, fontWeight: 600 }}>Payment Details</Label>
                    <select name="payment_details" className="form-control" onChange={e => onValueChange(e)}>
                      <option>Select</option><option>Card</option><option>EFT</option><option>Cash</option><option>Other</option>
                    </select>
                  </div></Col>
                  <Col md={3}><div className="mb-3">
                    <Label style={{ fontSize: 12, fontWeight: 600 }}>Delivery — Ship To</Label>
                    <select name="delivery_info" className="form-control" onChange={e => onValueChange(e)}>
                      <option>Select</option><option>Client Address</option><option>Client to Collect</option>
                    </select>
                  </div></Col>
                  <Input type="text" hidden name="patient_id" value={addData.patient_id} onChange={e => onValueChange(e)} />
                </Row>
              </CardBody>
            </Card>

            {/* ══════════════════════════════════════
                §2  FRAME DETAILS
            ══════════════════════════════════════ */}
            <Card className="mb-3" style={{ border: "none", borderRadius: 10, boxShadow: "0 2px 12px rgba(0,0,0,0.07)" }}>
              <div style={{ background: "linear-gradient(90deg,#f46a6a,#ff8282)", padding: "10px 20px", borderRadius: "10px 10px 0 0", display: "flex", alignItems: "center", gap: 8 }}>
                <span style={{ background: "rgba(255,255,255,0.25)", color: "#fff", borderRadius: "50%", width: 22, height: 22, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 11, fontWeight: 800 }}>2</span>
                <span style={{ color: "#fff", fontWeight: 700, fontSize: 13 }}>Frame Details</span>
              </div>
              <CardBody className="pt-3 pb-2">
                {/* Frame supply toggle */}
                <div className="mb-3 d-flex align-items-center" style={{ gap: 12 }}>
                  <span style={{ fontSize: 12, fontWeight: 700, color: "#495057" }}>Frame Supply:</span>
                  <div style={{ display: "inline-flex", border: "1px solid #f46a6a", borderRadius: 6, overflow: "hidden" }}>
                    {["Supply Frame", "Own Frame", "Frame to Follow"].map((opt, idx, arr) => (
                      <button key={opt} type="button"
                        onClick={() => onValueChange({ target: { name: "frame", value: opt } })}
                        style={{ padding: "4px 13px", fontSize: 11, fontWeight: 600, border: "none", borderRight: idx < arr.length - 1 ? "1px solid #f46a6a" : "none", background: addData.frame === opt ? "#f46a6a" : "#fff", color: addData.frame === opt ? "#fff" : "#f46a6a", cursor: "pointer", transition: "background 0.15s" }}>
                        {opt}
                      </button>
                    ))}
                  </div>
                </div>

                {isLabToSupply && (
                  <>
                    <Row className="mb-2">
                      <Col md={2}><div className="mb-3 position-relative">
                        <Label style={{ fontSize: 12, fontWeight: 600 }}>Frame Code</Label>
                        <Input type="text" className="form-control" name="framecode" value={addData.framecode || ""}
                          onChange={(e) => { onValueChange(e); setFrameSearchTerm(e.target.value); }} autoComplete="off" />
                        {frameSuggestions.length > 0 && (
                          <div className="position-absolute bg-white border rounded shadow-sm mt-1" style={{ zIndex: 1000, width: "100%" }}>
                            {frameSuggestions.map((frame, index) => (
                              <div key={index} className="px-2 py-1" style={{ cursor: "pointer", fontSize: 12 }}
                                onClick={async () => {
                                  try {
                                    setAddData(prev => ({ ...prev, framecode: frame.fcode, frame_name: frame.fname }));
                                    setFrameSuggestions([]); setFrameSearchTerm('');
                                    const response = await getFrameByFcode(frame.fcode);
                                    if (response?.data?.data?.length > 0) {
                                      const fd = response.data.data[0];
                                      setAddData(prev => ({
                                        ...prev,
                                        framecode: fd.fcode, frame_name: fd.fname, fqty: fd.fqty || 0,
                                        fname_id: fd.fname_id?._id || "", frame_id: fd.fname_id?._id || "",
                                        frame_brand: fd.fname_id?.frame_name || prev.frame_brand,
                                        frame_color: fd.fname_id?.frame_color || "",
                                        frame_size: fd.fname_id?.frame_size || "", frame_material: fd.fname_id?.frame_material || "",
                                        frame_type: fd.fname_id?.frame_type || "", frame_shape: fd.fname_id?.frame_shape || "",
                                        frame_price: fd.fname_id?.price || "",
                                        frameStockId: fd._id || "",
                                      }));
                                    }
                                  } catch (error) { console.error("Error fetching frame:", error); }
                                }}>
                                {frame.fcode} — <small>{frame.fname_id.frame_title}</small>
                              </div>
                            ))}
                          </div>
                        )}
                      </div></Col>
                      <Input type="text" hidden name="frameStockId" value={addData.frameStockId} onChange={e => onValueChange(e)} />
                      <Col md={2}><div className="mb-3">
                        <Label style={{ fontSize: 12, fontWeight: 600 }}>Color</Label>
                        <Input type="text" className="form-control" name="frame_color" value={addData.frame_color} onChange={e => onValueChange(e)} />
                      </div></Col>
                      <Col md={2}><div className="mb-3">
                        <Label style={{ fontSize: 12, fontWeight: 600 }}>Size</Label>
                        <Input type="text" className="form-control" name="frame_size" value={addData.frame_size} onChange={e => onValueChange(e)} />
                      </div></Col>
                      <Col md={2}><div className="mb-3">
                        <Label style={{ fontSize: 12, fontWeight: 600 }}>Brand</Label>
                        <Input type="text" className="form-control" name="frame_brand" value={addData.frame_brand} onChange={e => onValueChange(e)} />
                      </div></Col>
                      <Col md={2}><div className="mb-3">
                        <Label style={{ fontSize: 12, fontWeight: 600 }}>Price</Label>
                        <Input type="number" className="form-control" name="frame_price" value={addData.frame_price || ""} onChange={e => onValueChange(e)} />
                      </div></Col>
                      <Col md={2}><div className="mb-3">
                        <Label style={{ fontSize: 12, fontWeight: 600 }}>Photo</Label>
                        <div className="d-flex align-items-center" style={{ gap: 8 }}>
                          <Button color="light" onClick={() => setFrameCaptureModal(true)}
                            style={{ border: "1px solid #dee2e6", background: "#f8f9fa", fontSize: 22, padding: "2px 10px", borderRadius: 6 }}>📷</Button>
                          {webcamImage && (
                            <img src={webcamImage} alt="frame" onClick={() => setImageZoomModal(true)}
                              style={{ width: 42, height: 42, borderRadius: "50%", objectFit: "cover", border: "2px solid #f46a6a", cursor: "zoom-in" }} />
                          )}
                        </div>
                      </div></Col>
                    </Row>
                    {/* Material / Type / Shape pill toggles */}
                    <Row className="g-3">
                      <Col md={4}><div>
                        <Label style={{ fontSize: 12, fontWeight: 700, display: "block", marginBottom: 5 }}>Material</Label>
                        <div style={{ display: "inline-flex", border: "1px solid #f46a6a", borderRadius: 6, overflow: "hidden" }}>
                          {["Acetate", "Titanium", "Nylon"].map((opt, idx, arr) => (
                            <button key={opt} type="button" onClick={() => onValueChange({ target: { name: "frame_material", value: opt } })}
                              style={{ padding: "3px 12px", fontSize: 11, fontWeight: 600, border: "none", borderRight: idx < arr.length - 1 ? "1px solid #f46a6a" : "none", background: addData.frame_material === opt ? "#f46a6a" : "#fff", color: addData.frame_material === opt ? "#fff" : "#f46a6a", cursor: "pointer" }}>
                              {opt}
                            </button>
                          ))}
                        </div>
                      </div></Col>
                      <Col md={4}><div>
                        <Label style={{ fontSize: 12, fontWeight: 700, display: "block", marginBottom: 5 }}>Type</Label>
                        <div style={{ display: "inline-flex", border: "1px solid #f46a6a", borderRadius: 6, overflow: "hidden" }}>
                          {["Full Rim", "Semi-rimless", "Rimless"].map((opt, idx, arr) => (
                            <button key={opt} type="button" onClick={() => onValueChange({ target: { name: "frame_type", value: opt } })}
                              style={{ padding: "3px 12px", fontSize: 11, fontWeight: 600, border: "none", borderRight: idx < arr.length - 1 ? "1px solid #f46a6a" : "none", background: addData.frame_type === opt ? "#f46a6a" : "#fff", color: addData.frame_type === opt ? "#fff" : "#f46a6a", cursor: "pointer" }}>
                              {opt}
                            </button>
                          ))}
                        </div>
                      </div></Col>
                      <Col md={4}><div>
                        <Label style={{ fontSize: 12, fontWeight: 700, display: "block", marginBottom: 5 }}>Shape</Label>
                        <div style={{ display: "inline-flex", border: "1px solid #f46a6a", borderRadius: 6, overflow: "hidden" }}>
                          {["Rectangle", "cat-eye", "Round", "Oval"].map((opt, idx, arr) => (
                            <button key={opt} type="button" onClick={() => onValueChange({ target: { name: "frame_shape", value: opt } })}
                              style={{ padding: "3px 12px", fontSize: 11, fontWeight: 600, border: "none", borderRight: idx < arr.length - 1 ? "1px solid #f46a6a" : "none", background: addData.frame_shape === opt ? "#f46a6a" : "#fff", color: addData.frame_shape === opt ? "#fff" : "#f46a6a", cursor: "pointer" }}>
                              {opt}
                            </button>
                          ))}
                        </div>
                      </div></Col>
                    </Row>
                  </>
                )}
              </CardBody>
            </Card>

            {/* ══════════════════════════════════════
                §3  PRESCRIPTION & LENS
            ══════════════════════════════════════ */}
            <Card className="mb-3" style={{ border: "none", borderRadius: 10, boxShadow: "0 2px 12px rgba(0,0,0,0.07)" }}>
              <div style={{ background: "linear-gradient(90deg,#f46a6a,#ff8282)", padding: "10px 20px", borderRadius: "10px 10px 0 0", display: "flex", alignItems: "center", gap: 8 }}>
                <span style={{ background: "rgba(255,255,255,0.25)", color: "#fff", borderRadius: "50%", width: 22, height: 22, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 11, fontWeight: 800 }}>3</span>
                <span style={{ color: "#fff", fontWeight: 700, fontSize: 13 }}>Prescription & Lens Details</span>
              </div>
              <CardBody className="pt-3 pb-2">
                {prescriptionFromRef && (
                  <div style={{ display: "flex", alignItems: "center", gap: 8, background: "#eaf4ff", border: "1px solid #b6d9f7", borderRadius: 6, padding: "7px 14px", marginBottom: 16, fontSize: 12, color: "#1a6fad" }}>
                    <i className="mdi mdi-information-outline" style={{ fontSize: 15 }} />
                    Prescription auto-filled from <strong style={{ marginLeft: 4 }}>{prescriptionFromRef}</strong>
                  </div>
                )}
                <Row>

                  {/* ── Left: Lens Selector ── */}
                  <Col md={4} style={{ borderRight: "1px solid #f0f0f0", paddingRight: 20 }}>
                    <div className="mb-3">
                      <Label style={{ fontSize: 12, fontWeight: 700 }}>Lens Code</Label>
                      <div style={{ position: "relative" }}>
                        <Input type="text" className="form-control" name="lenscode" value={addData.lenscode || ""}
                          onChange={(e) => { onValueChange(e); setLenseSearchTerm(e.target.value); }} />
                        {lensSuggestions.length > 0 && (
                          <div className="position-absolute bg-white border rounded shadow-sm mt-1" style={{ zIndex: 1000, width: "100%" }}>
                            {lensSuggestions.map((lens, index) => (
                              <div key={index} className="px-2 py-1" style={{ cursor: "pointer", fontSize: 12 }}
                                onClick={() => {
                                  setAddData(prev => ({ ...prev, lenscode: lens.lcode, lens_name: lens.lname, lenseStockId: lens._id || "" }));
                                  setLensSuggestions([]); setLenseSearchTerm('');
                                }}>
                                {lens.lcode} — <small>{lens.lname_id?.lens_title}</small>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                    <Input type="text" name="lenseStockId" value={addData.lenseStockId} onChange={e => onValueChange(e)} hidden />

                    {/* OD card */}
                    <div className="rounded p-3 mb-3" style={{ background: "#fff5f5", border: "1px solid #ffd0d0" }}>
                      <div className="d-flex align-items-center mb-2" style={{ gap: 7 }}>
                        <span style={{ background: "#DC4C64", color: "#fff", borderRadius: 4, padding: "2px 8px", fontSize: 11, fontWeight: 700 }}>OD</span>
                        <span style={{ fontSize: 13, fontWeight: 600, color: "#DC4C64" }}>Right Eye</span>
                      </div>
                      <Label style={{ fontSize: 11, fontWeight: 700, color: "#666", marginBottom: 4, display: "block" }}>Lens Category</Label>
                      <div style={{ display: "flex", flexWrap: "wrap", gap: 4, marginBottom: 8 }}>
                        {["CR-39(Plastic)", "Glass", "Polycarbonate", "Uncut"].map(mat => (
                          <button key={mat} type="button"
                            onClick={() => onValueChange({ target: { name: "lens_material_od", value: mat } })}
                            style={{ padding: "3px 8px", fontSize: 10, fontWeight: 600, border: "1px solid #DC4C64", borderRadius: 4, background: addData.lens_material_od === mat ? "#DC4C64" : "#fff", color: addData.lens_material_od === mat ? "#fff" : "#DC4C64", cursor: "pointer" }}>
                            {mat}
                          </button>
                        ))}
                      </div>
                      <select name="lens_vision_od" className="form-control form-control-sm mb-2" value={addData.lens_vision_od || ""} onChange={handleVisionChangeOD}>
                        <option value="">Select Vision (OD)</option>
                        {vision.users.map((u, i) => <option key={i} value={u._id}>{u.vision}</option>)}
                      </select>
                      <select name="lens_subvision_od" className="form-control form-control-sm mb-2" value={addData.lens_subvision_od || ""} onChange={handleSubvisionChangeOD}>
                        <option value="">Select Sub-Type (OD)</option>
                        {filteredOptionsVisionTypeOD.map((vt, i) => <option key={i} value={vt._id}>{vt.sub_type}</option>)}
                      </select>
                      <Label style={{ fontSize: 11, fontWeight: 700, color: "#666", marginBottom: 4, display: "block" }}>Coating</Label>
                      <div style={{ display: "flex", flexWrap: "wrap", gap: 4, marginBottom: 8 }}>
                        {[{ value: "uc", label: "UC" }, { value: "hc", label: "HC" }, { value: "hmc_blue", label: "HMC Blue" }, { value: "shmc_blue", label: "SHMC" }].map(opt => (
                          <button key={opt.value} type="button"
                            onClick={() => handleCoatingChangeOD({ target: { name: "lens_type_od", value: opt.value } })}
                            style={{ padding: "3px 8px", fontSize: 10, fontWeight: 600, border: "1px solid #DC4C64", borderRadius: 4, background: addData.lens_type_od === opt.value ? "#DC4C64" : "#fff", color: addData.lens_type_od === opt.value ? "#fff" : "#DC4C64", cursor: "pointer" }}>
                            {opt.label}{totalsOD[opt.value] ? <span style={{ marginLeft: 2, fontSize: 9 }}>(R{parseFloat(totalsOD[opt.value]).toFixed(0)})</span> : null}
                          </button>
                        ))}
                      </div>
                      <div className="d-flex align-items-center" style={{ gap: 6 }}>
                        <input type="checkbox" id="lab_photochromic_od" checked={isPhotochromicOD} onChange={handlePhotochromicChangeOD} style={{ width: 14, height: 14, accentColor: "#DC4C64", cursor: "pointer" }} />
                        <label htmlFor="lab_photochromic_od" style={{ margin: 0, fontSize: 12, cursor: "pointer" }}>
                          Photochromic{totalsOD.photo ? <span style={{ color: "#DC4C64", marginLeft: 3, fontSize: 10 }}>(+R{parseFloat(totalsOD.photo).toFixed(0)})</span> : null}
                        </label>
                      </div>
                      {selectedTotalOD > 0 && <div style={{ textAlign: "right", fontWeight: 700, fontSize: 12, color: "#DC4C64", marginTop: 6 }}>OD: R {selectedTotalOD.toFixed(2)}</div>}
                    </div>

                    {/* OS card */}
                    <div className="rounded p-3" style={{ background: "#f0f5ff", border: "1px solid #c7d9f7" }}>
                      <div className="d-flex align-items-center mb-2" style={{ gap: 7 }}>
                        <span style={{ background: "#3b82f6", color: "#fff", borderRadius: 4, padding: "2px 8px", fontSize: 11, fontWeight: 700 }}>OS</span>
                        <span style={{ fontSize: 13, fontWeight: 600, color: "#3b82f6" }}>Left Eye</span>
                      </div>
                      <Label style={{ fontSize: 11, fontWeight: 700, color: "#666", marginBottom: 4, display: "block" }}>Lens Category</Label>
                      <div style={{ display: "flex", flexWrap: "wrap", gap: 4, marginBottom: 8 }}>
                        {["CR-39(Plastic)", "Glass", "Polycarbonate", "Uncut"].map(mat => (
                          <button key={mat} type="button"
                            onClick={() => onValueChange({ target: { name: "lens_material_os", value: mat } })}
                            style={{ padding: "3px 8px", fontSize: 10, fontWeight: 600, border: "1px solid #3b82f6", borderRadius: 4, background: addData.lens_material_os === mat ? "#3b82f6" : "#fff", color: addData.lens_material_os === mat ? "#fff" : "#3b82f6", cursor: "pointer" }}>
                            {mat}
                          </button>
                        ))}
                      </div>
                      <select name="lens_vision_os" className="form-control form-control-sm mb-2" value={addData.lens_vision_os || ""} onChange={handleVisionChangeOS}>
                        <option value="">Select Vision (OS)</option>
                        {vision.users.map((u, i) => <option key={i} value={u._id}>{u.vision}</option>)}
                      </select>
                      <select name="lens_subvision_os" className="form-control form-control-sm mb-2" value={addData.lens_subvision_os || ""} onChange={handleSubvisionChangeOS}>
                        <option value="">Select Sub-Type (OS)</option>
                        {filteredOptionsVisionTypeOS.map((vt, i) => <option key={i} value={vt._id}>{vt.sub_type}</option>)}
                      </select>
                      <Label style={{ fontSize: 11, fontWeight: 700, color: "#666", marginBottom: 4, display: "block" }}>Coating</Label>
                      <div style={{ display: "flex", flexWrap: "wrap", gap: 4, marginBottom: 8 }}>
                        {[{ value: "uc", label: "UC" }, { value: "hc", label: "HC" }, { value: "hmc_blue", label: "HMC Blue" }, { value: "shmc_blue", label: "SHMC" }].map(opt => (
                          <button key={opt.value} type="button"
                            onClick={() => handleCoatingChangeOS({ target: { name: "lens_type_os", value: opt.value } })}
                            style={{ padding: "3px 8px", fontSize: 10, fontWeight: 600, border: "1px solid #3b82f6", borderRadius: 4, background: addData.lens_type_os === opt.value ? "#3b82f6" : "#fff", color: addData.lens_type_os === opt.value ? "#fff" : "#3b82f6", cursor: "pointer" }}>
                            {opt.label}{totalsOS[opt.value] ? <span style={{ marginLeft: 2, fontSize: 9 }}>(R{parseFloat(totalsOS[opt.value]).toFixed(0)})</span> : null}
                          </button>
                        ))}
                      </div>
                      <div className="d-flex align-items-center" style={{ gap: 6 }}>
                        <input type="checkbox" id="lab_photochromic_os" checked={isPhotochromicOS} onChange={handlePhotochromicChangeOS} style={{ width: 14, height: 14, accentColor: "#3b82f6", cursor: "pointer" }} />
                        <label htmlFor="lab_photochromic_os" style={{ margin: 0, fontSize: 12, cursor: "pointer" }}>
                          Photochromic{totalsOS.photo ? <span style={{ color: "#3b82f6", marginLeft: 3, fontSize: 10 }}>(+R{parseFloat(totalsOS.photo).toFixed(0)})</span> : null}
                        </label>
                      </div>
                      {selectedTotalOS > 0 && <div style={{ textAlign: "right", fontWeight: 700, fontSize: 12, color: "#3b82f6", marginTop: 6 }}>OS: R {selectedTotalOS.toFixed(2)}</div>}
                    </div>
                  </Col>

                  {/* ── Right: Prescription + PD + Prism ── */}
                  <Col md={8} style={{ paddingLeft: 20 }}>
                    <h6 style={{ fontWeight: 700, color: "#495057", borderBottom: "2px solid #f46a6a", paddingBottom: 6, marginBottom: 12 }}>Prescription</h6>
                    <div className="table-responsive mb-3">
                      <Table className="table table-bordered mb-0" style={{ fontSize: 13 }}>
                        <thead>
                          <tr style={{ background: "#f8f9fa" }}>
                            <th style={{ width: 90, background: "#f8f9fa" }}></th>
                            <th style={{ background: "#f8f9fa" }}>Sphere</th>
                            <th style={{ background: "#f8f9fa" }}>Cyl</th>
                            <th style={{ background: "#f8f9fa" }}>Axis</th>
                            <th style={{ background: "#f8f9fa" }}>Add</th>
                            <th style={{ background: "#f8f9fa" }}>Seg Height</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <th style={{ background: "#fff0f0", color: "#DC4C64", fontWeight: 700, fontSize: 12 }}>OD [R]</th>
                            <td><Input type="text" className="form-control form-control-sm" name="od_spere" value={addData.od_spere} onClick={() => handleInputClick("od_spere")} onChange={onValueChange} /></td>
                            <td><Input type="text" className="form-control form-control-sm" name="od_cyl" value={addData.od_cyl} onClick={() => handleInputClick1("od_cyl")} onChange={onValueChange} /></td>
                            <td><select name="od_axis" className="form-control form-control-sm" value={addData.od_axis || ""} onChange={e => onValueChange(e)}><option value="">—</option>{renderDropdownOptions()}</select></td>
                            <td><select name="od_add" className="form-control form-control-sm" value={addData.od_add || ""} onChange={e => onValueChange(e)}><option value="">—</option>{["+0.75", "+1.00", "+1.25", "+1.50", "+1.75", "+2.00", "+2.25", "+2.50", "+2.75", "+3.00", "+3.25", "+3.50"].map(v => <option key={v}>{v}</option>)}</select></td>
                            <td><select name="od_seg_height" className="form-control form-control-sm" value={addData.od_seg_height || ""} onChange={e => onValueChange(e)}><option value="">—</option>{renderDropdownOptions1()}</select></td>
                          </tr>
                          <tr>
                            <th style={{ background: "#f0f5ff", color: "#3b82f6", fontWeight: 700, fontSize: 12 }}>OS [L]</th>
                            <td><Input type="text" className="form-control form-control-sm" name="os_spere" value={addData.os_spere} onClick={() => handleInputClick("os_spere")} onChange={onValueChange} /></td>
                            <td><Input type="text" className="form-control form-control-sm" name="os_cyl" value={addData.os_cyl} onClick={() => handleInputClick1("os_cyl")} onChange={onValueChange} /></td>
                            <td><select name="os_axis" className="form-control form-control-sm" value={addData.os_axis || ""} onChange={e => onValueChange(e)}><option value="">—</option>{renderDropdownOptions()}</select></td>
                            <td><select name="os_add" className="form-control form-control-sm" value={addData.os_add || ""} onChange={e => onValueChange(e)}><option value="">—</option>{["+0.75", "+1.00", "+1.25", "+1.50", "+1.75", "+2.00", "+2.25", "+2.50", "+2.75", "+3.00", "+3.25", "+3.50"].map(v => <option key={v}>{v}</option>)}</select></td>
                            <td><select name="os_seg_height" className="form-control form-control-sm" value={addData.os_seg_height || ""} onChange={e => onValueChange(e)}><option value="">—</option>{renderDropdownOptions1()}</select></td>
                          </tr>
                        </tbody>
                      </Table>
                    </div>

                    <p style={{ fontSize: 12, color: "#666", marginBottom: 12 }}>
                      Or <span style={{ color: "#f46a6a", textDecoration: "underline", cursor: "pointer" }} onClick={handleClick}>upload prescription paper here</span>.
                      <input type="file" className="form-control" name="sizeframe3" ref={fileInputRef} style={{ display: "none" }} onChange={e => onValueChange(e)} />
                    </p>

                    {/* PD Section */}
                    <div className="p-3 rounded mb-3" style={{ background: "#fafafa", border: "1px solid #e9ecef" }}>
                      <h6 style={{ fontWeight: 700, color: "#495057", borderBottom: "1px solid #e9ecef", paddingBottom: 5, marginBottom: 10, fontSize: 13 }}>PD — Pupillary Distance</h6>
                      <Row className="align-items-center g-2">
                        {!isTwoPD && (
                          <Col md={4}>
                            <Label style={{ fontSize: 12 }}>PD</Label>
                            <Input type="text" className="form-control form-control-sm" name="pd" placeholder="PD" value={addData.pd} onClick={() => handleInputClick2("pd")} onChange={e => onValueChange(e)} />
                          </Col>
                        )}
                        {isTwoPD && (<>
                          <Col md={3}>
                            <Label style={{ fontSize: 12 }}>PD Left</Label>
                            <Input type="text" className="form-control form-control-sm" name="pd_left" placeholder="PD Left" value={addData.pd_left} onClick={() => handleInputClick3("pd_left")} onChange={e => onValueChange(e)} />
                          </Col>
                          <Col md={3}>
                            <Label style={{ fontSize: 12 }}>PD Right</Label>
                            <Input type="text" className="form-control form-control-sm" name="pd_right" placeholder="PD Right" value={addData.pd_right} onClick={() => handleInputClick3("pd_right")} onChange={e => onValueChange(e)} />
                          </Col>
                        </>)}
                        <Col md={4} className="pt-2">
                          <div className="form-check">
                            <input className="form-check-input" type="checkbox" id="two_pd_number" checked={isTwoPD} onChange={onCheckboxChange} />
                            <label className="form-check-label" htmlFor="twoPdCheckbox" style={{ fontSize: 12 }}>Two PD Numbers</label>
                          </div>
                        </Col>
                      </Row>
                    </div>

                    {/* Prism */}
                    <div>
                      <div className="d-flex align-items-center mb-2" style={{ gap: 8 }}>
                        <input type="checkbox" id="addprism" name="add_prism" onChange={e => onValueChange(e)} style={{ width: 14, height: 14, accentColor: "#f46a6a", cursor: "pointer" }} />
                        <label htmlFor="addprism" style={{ fontSize: 13, fontWeight: 600, margin: 0, cursor: "pointer", color: "#495057" }}>Add Prism</label>
                      </div>
                      <div className="table-responsive">
                        <Table className="table table-bordered mb-0" style={{ fontSize: 12 }}>
                          <thead>
                            <tr style={{ background: "#f8f9fa" }}>
                              <th style={{ background: "#f8f9fa" }}></th>
                              <th style={{ background: "#f8f9fa" }}>Vertical (A)</th>
                              <th style={{ background: "#f8f9fa" }}>Base Dir.</th>
                              <th style={{ background: "#f8f9fa" }}>Horizontal (A)</th>
                              <th style={{ background: "#f8f9fa" }}>Base Dir.</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <th style={{ background: "#fff0f0", color: "#DC4C64", fontSize: 11, fontWeight: 700 }}>OD</th>
                              <td><select name="od_vertical" className="form-control form-control-sm" onChange={e => onValueChange(e)}><option>Select</option>{["0.50", "1.50", "2.00", "2.50", "3.00", "3.50", "4.00", "4.50", "5.00", "5.50", "6.00"].map(v => <option key={v}>{v}</option>)}</select></td>
                              <td><select name="od_vb_direction" className="form-control form-control-sm" onChange={e => onValueChange(e)}><option>Base Dir.</option><option>Up</option><option>Down</option></select></td>
                              <td><select name="od_hb_direction" className="form-control form-control-sm" onChange={e => onValueChange(e)}><option>Select</option>{["0.50", "1.50", "2.00", "2.50", "3.00", "3.50", "4.00", "4.50", "5.00", "5.50", "6.00"].map(v => <option key={v}>{v}</option>)}</select></td>
                              <td><select name="od_horizontal" className="form-control form-control-sm" onChange={e => onValueChange(e)}><option>Base Dir.</option><option>IN</option><option>OUT</option></select></td>
                            </tr>
                            <tr>
                              <th style={{ background: "#f0f5ff", color: "#3b82f6", fontSize: 11, fontWeight: 700 }}>OS</th>
                              <td><select name="os_vertical" className="form-control form-control-sm" onChange={e => onValueChange(e)}><option>Select</option>{["0.50", "1.50", "2.00", "2.50", "3.00", "3.50", "4.00", "4.50", "5.00", "5.50", "6.00"].map(v => <option key={v}>{v}</option>)}</select></td>
                              <td><select name="os_vb_direction" className="form-control form-control-sm" onChange={e => onValueChange(e)}><option>Base Dir.</option><option>Up</option><option>Down</option></select></td>
                              <td><select name="os_horizontal" className="form-control form-control-sm" onChange={e => onValueChange(e)}><option>Select</option>{["0.50", "1.50", "2.00", "2.50", "3.00", "3.50", "4.00", "4.50", "5.00", "5.50", "6.00"].map(v => <option key={v}>{v}</option>)}</select></td>
                              <td><select name="os_hb_direction" className="form-control form-control-sm" onChange={e => onValueChange(e)}><option>Base Dir.</option><option>IN</option><option>OUT</option>{renderDropdownOptions1()}</select></td>
                            </tr>
                          </tbody>
                        </Table>
                      </div>
                    </div>

                    {/* SPH Modal */}
                    <Modal isOpen={modalOpen} toggle={() => setModalOpen(!modalOpen)}>
                      <ModalHeader toggle={() => setModalOpen(!modalOpen)}>SPH (Right)</ModalHeader>
                      <ModalBody>
                        <Row>
                          <Col md={6}><h5>(-) Minus values</h5>
                            {["-0.25", "-0.50", "-0.75", "-1.00", "-1.50", "-1.75", "-2.00", "-2.00", "-2.25", "-2.50", "-2.75", "-3.00", "-3.25", "-3.50", "-3.75", "-4.00", "-4.25", "-4.50", "-4.75", "-5.00", "-5.25"].map((value, index) => (
                              <Button key={index} outline="secondary" style={{ margin: "5px", width: "calc(30% - 10px)" }} onClick={() => handleSelectValue(value)}>{value}</Button>
                            ))}
                          </Col>
                          <Col md={6}><h5>(+) Plus values</h5>
                            {["+0.25", "+0.50", "+0.75", "+1.00", "+1.50", "+1.75", "+2.00", "+2.00", "+2.25", "+2.50", "+2.75", "+3.00", "+3.25", "+3.50", "+3.75", "+4.00", "+4.25", "+4.50", "+4.75", "+5.00", "+5.25"].map((value, index) => (
                              <Button key={index} outline="secondary" style={{ margin: "5px", width: "calc(30% - 10px)" }} onClick={() => handleSelectValue(value)}>{value}</Button>
                            ))}
                          </Col>
                        </Row>
                      </ModalBody>
                      <ModalFooter></ModalFooter>
                    </Modal>

                    {/* CYL Modal */}
                    <Modal isOpen={modalOpen1} toggle={() => setModalOpen1(!modalOpen1)}>
                      <ModalHeader toggle={() => setModalOpen1(!modalOpen1)}>CYL (Right)</ModalHeader>
                      <ModalBody>
                        <h5>(-) Minus values</h5>
                        {["-0.25", "-0.50", "-0.75", "-1.00", "-1.50", "-1.75", "-2.00", "-2.00", "-2.25", "-2.50", "-2.75", "-3.00", "-3.25", "-3.50", "-3.75", "-4.00", "-4.25", "-4.50", "-4.75", "-5.00", "-5.25", "-6.00", "-6.25", "-6.50"].map((value, index) => (
                          <Button key={index} outline="secondary" style={{ margin: "5px", width: "calc(15% - 10px)" }} onClick={() => handleSelectValue1(value)}>{value}</Button>
                        ))}
                      </ModalBody>
                      <ModalFooter></ModalFooter>
                    </Modal>

                    {/* PD Modal */}
                    <Modal isOpen={modalOpen2} toggle={() => setModalOpen2(!modalOpen2)}>
                      <ModalHeader toggle={() => setModalOpen2(!modalOpen2)}>PD (Pupillary Distance)</ModalHeader>
                      <ModalBody>
                        {["54.00", "54.50", "55.00", "55.50", "56.00", "56.50", "57.00", "57.50", "58.00", "58.50", "59.00", "59.50", "60.00", "60.50", "61.00", "61.50", "62.00", "62.50", "63.00", "63.50", "64.00", "64.50", "65.00", "65.50", "66.00", "66.50", "67.00", "67.50", "68.00", "68.50", "69.00", "69.50", "70.00", "70.50", "71.00", "71.50", "72.00", "72.50", "73.00", "73.50", "74.00", "74.50", "75.00", "75.50", "76.00", "76.50", "77.00", "77.50", "78.00", "78.50"].map((value, index) => (
                          <Button key={index} outline="secondary" style={{ margin: "5px", width: "calc(15% - 10px)" }} onClick={() => handleSelectValue2(value)}>{value}</Button>
                        ))}
                      </ModalBody>
                      <ModalFooter></ModalFooter>
                    </Modal>

                    {/* PD Left Modal */}
                    <Modal isOpen={modalOpen3} toggle={() => setModalOpen3(!modalOpen3)}>
                      <ModalHeader toggle={() => setModalOpen3(!modalOpen3)}>PD (Left)</ModalHeader>
                      <ModalBody>
                        {["25.00", "25.50", "26.00", "26.50", "27.00", "27.50", "28.00", "28.50", "29.00", "29.50", "30.00", "30.50", "31.00", "31.50", "32.00", "32.50", "33.00", "33.50", "34.00", "34.50"].map((value, index) => (
                          <Button key={index} outline="secondary" style={{ margin: "5px", width: "calc(15% - 10px)" }} onClick={() => handleSelectValue3(value)}>{value}</Button>
                        ))}
                      </ModalBody>
                      <ModalFooter></ModalFooter>
                    </Modal>

                  </Col>
                </Row>
              </CardBody>
            </Card>

            {/* ══════════════════════════════════════
                §4+5  REVIEW + TOTAL
            ══════════════════════════════════════ */}
            <Row className="mb-3">
              <Col md={12}>
                <Card style={{ border: "none", borderRadius: 10, boxShadow: "0 2px 12px rgba(0,0,0,0.07)" }}>
                  <div style={{ background: "linear-gradient(90deg,#f46a6a,#ff8282)", padding: "10px 20px", borderRadius: "10px 10px 0 0", display: "flex", alignItems: "center", gap: 8 }}>
                    <span style={{ background: "rgba(255,255,255,0.25)", color: "#fff", borderRadius: "50%", width: 22, height: 22, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 11, fontWeight: 800 }}>4</span>
                    <span style={{ color: "#fff", fontWeight: 700, fontSize: 13 }}>Review Your Order</span>
                  </div>
                  <CardBody style={{ fontSize: 13 }}>
                    <Row>
                      <Col md={4}>
                        <p style={{ fontSize: 11, fontWeight: 700, color: "#999", textTransform: "uppercase", letterSpacing: 1, marginBottom: 6 }}>Frame</p>
                        {[["Brand", addData.frame_brand], ["Code", addData.framecode], ["Color", addData.frame_color], ["Size", addData.frame_size], ["Material", addData.frame_material], ["Type", addData.frame_type], ["Shape", addData.frame_shape], ["Price", addData.frame_price ? `R ${parseFloat(addData.frame_price || 0).toFixed(2)}` : "—"]].map(([k, v]) => (
                          <div key={k} style={{ display: "flex", justifyContent: "space-between", fontSize: 12, marginBottom: 3, padding: "2px 0", borderBottom: "1px dotted #f0f0f0" }}>
                            <span style={{ color: "#888" }}>{k}</span><span style={{ fontWeight: 500 }}>{v || "—"}</span>
                          </div>
                        ))}
                      </Col>
                      <Col md={4}>
                        <p style={{ fontSize: 11, fontWeight: 700, color: "#DC4C64", textTransform: "uppercase", letterSpacing: 1, marginBottom: 6 }}>OD — Right Eye</p>
                        {[["Material", addData.lens_material_od], ["Vision", vision.users.find(u => u._id?.toString() === addData.lens_vision_od?.toString())?.vision], ["Coating", addData.lens_type_od ? addData.lens_type_od.toUpperCase() + (isPhotochromicOD ? " + Photo" : "") : null]].map(([k, v]) => (
                          <div key={k} style={{ display: "flex", justifyContent: "space-between", fontSize: 12, marginBottom: 3, padding: "2px 0", borderBottom: "1px dotted #f0f0f0" }}>
                            <span style={{ color: "#888" }}>{k}</span><span style={{ fontWeight: 500 }}>{v || "—"}</span>
                          </div>
                        ))}
                      </Col>
                      <Col md={4}>
                        <p style={{ fontSize: 11, fontWeight: 700, color: "#3b82f6", textTransform: "uppercase", letterSpacing: 1, marginBottom: 6 }}>OS — Left Eye</p>
                        {[["Material", addData.lens_material_os], ["Vision", vision.users.find(u => u._id?.toString() === addData.lens_vision_os?.toString())?.vision], ["Coating", addData.lens_type_os ? addData.lens_type_os.toUpperCase() + (isPhotochromicOS ? " + Photo" : "") : null]].map(([k, v]) => (
                          <div key={k} style={{ display: "flex", justifyContent: "space-between", fontSize: 12, marginBottom: 3, padding: "2px 0", borderBottom: "1px dotted #f0f0f0" }}>
                            <span style={{ color: "#888" }}>{k}</span><span style={{ fontWeight: 500 }}>{v || "—"}</span>
                          </div>
                        ))}
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>

            {/* ══════════════════════════════════════
                §6  AUTHORIZATION & NOTES
            ══════════════════════════════════════ */}
            <Card className="mb-4" style={{ border: "none", borderRadius: 10, boxShadow: "0 2px 12px rgba(0,0,0,0.07)" }}>
              <div style={{ background: "linear-gradient(90deg,#f46a6a,#ff8282)", padding: "10px 20px", borderRadius: "10px 10px 0 0", display: "flex", alignItems: "center", gap: 8 }}>
                <span style={{ background: "rgba(255,255,255,0.25)", color: "#fff", borderRadius: "50%", width: 22, height: 22, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 11, fontWeight: 800 }}>6</span>
                <span style={{ color: "#fff", fontWeight: 700, fontSize: 13 }}>Authorization & Notes</span>
              </div>
              <CardBody className="pt-3">
                <Row>
                  <Col md={3}><div className="mb-3">
                    <Label style={{ fontSize: 12, fontWeight: 600 }}>Authorized By <span className="text-danger">*</span></Label>
                    <Input type="text" className="form-control" name="authorized_by" placeholder="Authorized By" onChange={e => onValueChange(e)} />
                  </div></Col>
                  {/* <Col md={3}><div className="mb-3"> */}
                  {/* <Label style={{ fontSize: 12, fontWeight: 600 }}>Practice Name <span className="text-danger">*</span></Label> */}
                  <Input type="text" hidden className="form-control" name="practisc_name" value={addData.practisc_name} placeholder="Practice Name" onChange={e => onValueChange(e)} />
                  {/* </div></Col> */}
                  {/* <Col md={3}><div className="mb-3">
                    <Label style={{ fontSize: 12, fontWeight: 600 }}>Practice Contact No. <span className="text-danger">*</span></Label>
                    <Input type="text" className="form-control" name="px_number" maxLength={11} placeholder="Practice contact no." onChange={e => onValueChange(e)} />
                  </div></Col> */}
                  <Col md={3}><div className="mb-3">
                    <Label style={{ fontSize: 12, fontWeight: 600 }}>Additional Notes</Label>
                    <Input type="textarea" className="form-control" name="additional_notes" placeholder="Additional notes" onChange={e => onValueChange(e)} />
                  </div></Col>
                </Row>
                <Row>
                  <Col md={3}><div className="mb-3">
                    <Label style={{ fontSize: 12, fontWeight: 600 }}><b>Digital Signature</b></Label>
                    <div>
                      <SignatureCanvas penColor="black"
                        canvasProps={{ width: 220, height: 110, className: "signature-canvas", style: { border: "2px solid #dee2e6", borderRadius: 6 } }}
                        ref={ref => setSignatureRef(ref)} />
                    </div>
                    <div className="mt-2 d-flex gap-2">
                      <Button onClick={clearSignature} color="secondary" size="sm">Clear</Button>
                      <Button onClick={saveSignature} color="primary" size="sm">Sign</Button>
                      {signatureRef && <Button onClick={() => alert("Done")} color="success" size="sm">Done</Button>}
                    </div>
                  </div></Col>
                </Row>
              </CardBody>
            </Card>

            {/* ── Save Button ── */}
            <div className="text-end mb-4">
              <button className="btn px-5 py-2"
                style={{ background: "linear-gradient(90deg,#f46a6a,#ff8282)", color: "#fff", fontWeight: 700, fontSize: 14, borderRadius: 8, boxShadow: "0 3px 12px rgba(244,106,106,0.4)", border: "none" }}
                onClick={e => handleSubmit(e)}>
                Save Lab Order
              </button>
            </div>

            {/* bottom padding so floating bar doesn't overlap save button */}
            <div style={{ height: 72 }} />

          </Form>

          {/* ── Floating Total Bar ── */}
          <div style={{
            position: "fixed", bottom: 0, left: 250, right: 0, zIndex: 1050,
            background: "#fff",
            borderTop: "3px solid #f46a6a",
            boxShadow: "0 -4px 24px rgba(0,0,0,0.10)",
            padding: "10px 32px",
            display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 6
          }}>
            <span style={{ color: "#999", fontSize: 11, fontWeight: 600, textTransform: "uppercase", letterSpacing: 1, marginRight: 8 }}>Order Total</span>

            {/* OD pill */}
            <div style={{ display: "flex", alignItems: "center", background: "#fff5f5", border: "1px solid #ffd0d0", borderRadius: 20, padding: "4px 14px", gap: 6 }}>
              <span style={{ width: 8, height: 8, borderRadius: "50%", background: "#DC4C64", flexShrink: 0 }} />
              <span style={{ color: "#DC4C64", fontSize: 11, fontWeight: 600 }}>OD</span>
              <span style={{ color: "#DC4C64", fontSize: 13, fontWeight: 700 }}>R {selectedTotalOD.toFixed(2)}</span>
            </div>

            <span style={{ color: "#ccc", fontSize: 16 }}>+</span>

            {/* OS pill */}
            <div style={{ display: "flex", alignItems: "center", background: "#f0f5ff", border: "1px solid #c7d9f7", borderRadius: 20, padding: "4px 14px", gap: 6 }}>
              <span style={{ width: 8, height: 8, borderRadius: "50%", background: "#3b82f6", flexShrink: 0 }} />
              <span style={{ color: "#3b82f6", fontSize: 11, fontWeight: 600 }}>OS</span>
              <span style={{ color: "#3b82f6", fontSize: 13, fontWeight: 700 }}>R {selectedTotalOS.toFixed(2)}</span>
            </div>

            <span style={{ color: "#ccc", fontSize: 16 }}>+</span>

            <div style={{ display: "flex", alignItems: "center", background: "#fff8ef", border: "1px solid #ffd8ad", borderRadius: 20, padding: "4px 14px", gap: 6 }}>
              <span style={{ width: 8, height: 8, borderRadius: "50%", background: "#f59e0b", flexShrink: 0 }} />
              <span style={{ color: "#c77a00", fontSize: 11, fontWeight: 600 }}>Frame</span>
              <span style={{ color: "#c77a00", fontSize: 13, fontWeight: 700 }}>R {framePrice.toFixed(2)}</span>
            </div>

            {/* divider */}
            <div style={{ width: 1, height: 28, background: "#e8e8e8", margin: "0 12px" }} />

            {/* Grand Total */}
            <div style={{ display: "flex", alignItems: "center", gap: 10, background: "linear-gradient(90deg,#fff5f5,#fff0f0)", border: "1.5px solid #f46a6a", borderRadius: 8, padding: "5px 18px" }}>
              <span style={{ color: "#f46a6a", fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: 0.5 }}>Grand Total</span>
              <span style={{ color: "#f46a6a", fontSize: 22, fontWeight: 800, letterSpacing: 0.5 }}>
                R {(selectedTotalOD + selectedTotalOS + framePrice).toFixed(2)}
              </span>
            </div>
          </div>

          <Modal isOpen={frameCaptureModal} toggle={() => setFrameCaptureModal(!frameCaptureModal)} size="lg">
            <ModalHeader toggle={() => setFrameCaptureModal(false)}>
              Capture Frame Image
            </ModalHeader>
            <ModalBody>
              <div className="d-flex flex-column align-items-center">
                <Webcam
                  audio={false}
                  ref={webcamRef}
                  screenshotFormat="image/jpeg"
                  width={500}
                  height={350}
                  videoConstraints={{ facingMode: "user" }}
                />
                <Button color="primary" className="mt-3" onClick={captureImage}>
                  Capture
                </Button>
              </div>
              {webcamImage && (
                <div className="text-center mt-3">
                  <p>Captured Image:</p>
                  <img src={webcamImage} alt="Captured" className="img-fluid" />
                </div>
              )}
            </ModalBody>
          </Modal>

          {/* ── Image Zoom Modal ── */}
          <Modal isOpen={imageZoomModal} toggle={() => setImageZoomModal(false)} centered size="lg">
            <ModalHeader toggle={() => setImageZoomModal(false)}>
              Captured Frame Image
            </ModalHeader>
            <ModalBody className="text-center p-3">
              {webcamImage && (
                <img
                  src={webcamImage}
                  alt="Captured Full Size"
                  style={{ maxWidth: "100%", maxHeight: "75vh", borderRadius: 8, objectFit: "contain" }}
                />
              )}
            </ModalBody>
          </Modal>
        </Container>
      </div>
    </React.Fragment >
  )
}

export default Addlaborder
